import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n';
import router from './router'
import { goToRouter } from './utils/tools';
import("@/assets/style/index.less");

Vue.config.productionTip = false
Vue.prototype.$goToRouter = goToRouter;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
